import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center justify-content-center mb-4" }
const _hoisted_2 = {
  filter: "category",
  sort: "category"
}
const _hoisted_3 = {
  filter: "underbust",
  sort: "underbust"
}
const _hoisted_4 = {
  filter: "cup",
  sort: "cup"
}
const _hoisted_5 = {
  filter: "outerCupsSQM",
  sort: "outerCupsSQM"
}
const _hoisted_6 = {
  filter: "innerCupsSQM",
  sort: "innerCupsSQM"
}
const _hoisted_7 = {
  filter: "strapsSQM",
  sort: "strapsSQM"
}
const _hoisted_8 = {
  filter: "sideWingsSQM",
  sort: "sideWingsSQM"
}
const _hoisted_9 = {
  filter: "underbustBandSQM",
  sort: "underbustBandSQM"
}
const _hoisted_10 = {
  filter: "centerGoreSQM",
  sort: "centerGoreSQM"
}
const _hoisted_11 = {
  filter: "hooksClosuresSQM",
  sort: "hooksClosuresSQM"
}
const _hoisted_12 = {
  filter: "underwireGrams",
  sort: "underwireGrams"
}
const _hoisted_13 = {
  filter: "paddingGrams",
  sort: "paddingGrams"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { colspan: "12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.uploadExcelModal()))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Upload Excel",
          text: "Upload Excel"
        })
      ])
    ]),
    _createVNode(_component_op_table, {
      class: "table table-striped",
      items: _ctx.configurations
    }, {
      default: _withCtx((opData) => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_2, [
              _createVNode(_component_localized_text, {
                localizedKey: "Category",
                text: "Category"
              })
            ]),
            _createElementVNode("td", _hoisted_3, [
              _createVNode(_component_localized_text, {
                localizedKey: "Underbust",
                text: "Underbust"
              })
            ]),
            _createElementVNode("td", _hoisted_4, [
              _createVNode(_component_localized_text, {
                localizedKey: "Cup",
                text: "Cup"
              })
            ]),
            _createElementVNode("td", _hoisted_5, [
              _createVNode(_component_localized_text, {
                localizedKey: "Outer cups (m²)",
                text: "Outer cups (m²)"
              })
            ]),
            _createElementVNode("td", _hoisted_6, [
              _createVNode(_component_localized_text, {
                localizedKey: "Inner cups (m²)",
                text: "Inner cups (m²)"
              })
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createVNode(_component_localized_text, {
                localizedKey: "Straps (m²)",
                text: "Straps (m²)"
              })
            ]),
            _createElementVNode("td", _hoisted_8, [
              _createVNode(_component_localized_text, {
                localizedKey: "Side wings (m²)",
                text: "Side wings (m²)"
              })
            ]),
            _createElementVNode("td", _hoisted_9, [
              _createVNode(_component_localized_text, {
                localizedKey: "Underbust band (m²)",
                text: "Underbust band (m²)"
              })
            ]),
            _createElementVNode("td", _hoisted_10, [
              _createVNode(_component_localized_text, {
                localizedKey: "Center gore (m²)",
                text: "Center gore (m²)"
              })
            ]),
            _createElementVNode("td", _hoisted_11, [
              _createVNode(_component_localized_text, {
                localizedKey: "Hooks/closures (m²)",
                text: "Hooks/closures (m²)"
              })
            ]),
            _createElementVNode("td", _hoisted_12, [
              _createVNode(_component_localized_text, {
                localizedKey: "Underwire (g)",
                text: "Underwire (g)"
              })
            ]),
            _createElementVNode("td", _hoisted_13, [
              _createVNode(_component_localized_text, {
                localizedKey: "Padding (g)",
                text: "Padding (g)"
              })
            ])
          ])
        ]),
        _createElementVNode("tbody", null, [
          (opData.data.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                _createElementVNode("td", _hoisted_15, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "No Elements Found",
                    text: "No Elements Found"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.data as OM.BraSquareMeterCombinationsConfig[]), (item, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, _toDisplayString(item.category), 1),
              _createElementVNode("td", null, _toDisplayString(item.underbust), 1),
              _createElementVNode("td", null, _toDisplayString(item.cup), 1),
              _createElementVNode("td", null, _toDisplayString(item.outerCupsSQM), 1),
              _createElementVNode("td", null, _toDisplayString(item.innerCupsSQM), 1),
              _createElementVNode("td", null, _toDisplayString(item.strapsSQM), 1),
              _createElementVNode("td", null, _toDisplayString(item.sideWingsSQM), 1),
              _createElementVNode("td", null, _toDisplayString(item.underbustBandSQM), 1),
              _createElementVNode("td", null, _toDisplayString(item.centerGoreSQM), 1),
              _createElementVNode("td", null, _toDisplayString(item.hooksClosuresSQM), 1),
              _createElementVNode("td", null, _toDisplayString(item.underwireGrams), 1),
              _createElementVNode("td", null, _toDisplayString(item.paddingGrams), 1)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["items"])
  ], 64))
}